export const CommonConfig = {
    iFrameId: 'OPLWCI',
    iFrameSrc: 'site-iframe.html'
};
